export default {
      id: "geolocation-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "icons.HITByrwA.svg#geolocation-usage",
      toString: function () {
        return this.url;
      }
    }